export enum DepartingType {
  FLIGHT = 'Flight',
  TRAIN = 'Train'
}
